import React, { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import PropTypes from "prop-types";
import {GREENERGENIC_CONFIG} from "config";
import { Formik, useFormik, Field, Form, useFormikContext } from "formik";
import { createTheme } from "@material-ui/core";
import { bindActionCreators } from 'redux';
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Grid,
  Typography,
  TextField,
  Button,
  Collapse
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import moment from 'moment';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {
  MAX_LENGTH,
  ev_model_list,
  simu_speed_list,
  simu_algorithm_list
} from "common/constants";
import {
  updateSimuSetting,
  updateMakeRandomEVData,
  updateChgrCnt
} from "actions/settings";
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import EVParamInput from "./components/evParamInput";
import firebase from '../../Firebase';
import { getDatabase, ref, onValue, set, get, child, remove } from 'firebase/database';

import i18n from 'i18n/i18n';  // i18n 객체 직접 import
import 'intl-pluralrules';


const INIT_SIMU_SPEED = '300'; //300배
const INIT_LC_MAX_SUPPLY = 30; //kWh
const INIT_ALGORITHM = 'basic';
const INIT_CHGR_CNT = 12;


const SmartChargingInput = (props) => {

  const { className, history, simuSettings, ...rest } = props;
  const classes = useStyles();

  const [openUsage, setOpenUsage] = useState(true);
  const [isReadyToStart, setReadyToStart] = useState(false);

  const database = getDatabase();
  const dbRef = ref(database);

  const selector_random_ev_data = useSelector((state) => state.simuSettings.random_ev_data);
  const selector_chgr_cnt = useSelector((state) => state.simuSettings.chgr_cnt);


  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      simu_speed: INIT_SIMU_SPEED,
      lc_max_supply: INIT_LC_MAX_SUPPLY,
      algorithm: INIT_ALGORITHM,
      chgr_cnt: INIT_CHGR_CNT,
      offset_date: moment().format('YY/MM/DD HH:mm')
    },
  });


  const isDateValid = (dateStr) => {
    // console.log(moment(dateStr));
    return moment(dateStr, 'YY/MM/DD HH:mm', true).isValid();
  }



  /**
   * 시뮬레이션 개시
   * @param {*} event 
   * @param {*} values 
   */
  const doStartSimu = (event, values) => {
    event.preventDefault();


    console.log(selector_random_ev_data);
    //check parameters;
    if(selector_random_ev_data == undefined || selector_random_ev_data.length == 0){
      alert('no data');
      return;
    }


    //설정된 CHGR count 이상의 결과 firebase를 삭제
    for(var i=selector_chgr_cnt; i<INIT_CHGR_CNT; i++){
      remove(child(dbRef, `simu/instantaneous/chgr/${i}`));
      remove(child(dbRef, `simu/summary/chgr/${i}`));
    }


    const json_body = JSON.stringify({
      simu_speed: parseInt(values.simu_speed),
      lc_max_supply: values.lc_max_supply * 1000,
      defaultProfile: 7000,
      algorithm: values.algorithm,
      // chgr_cnt: values.chgr_cnt,
      chgr_cnt: selector_chgr_cnt,
      offset_date: values.offset_date,
      // ev_data: selector_random_ev_data.map(item => JSON.stringify(item))
      ev_data: selector_random_ev_data.map(item => item)
    });


    fetch(`${GREENERGENIC_CONFIG.HOSTNAME}/simu_smartcharging`,
    {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: json_body
    })
    .then( response => {
      return response.json();
    }).then(responseData => {

      console.log(responseData);

      if(responseData.resultCode === 200){
        //성공

        // setReadyToStart(false);

        // const newuser = {
        //   status: 'on',
        //   user_auth : responseData.user_auth, //1:admin, 2:회원사
        //   admin_id: responseData.admin_id, //관리자 아이디, 회원사 아이디
        //   admin_name : responseData.admin_name, //관리자 이름, 회원사 이름
        //   bid: responseData.bid, //환경부GW BID
        //   bkey: responseData.bkey, //환경부GW BKEY
        // }

        // localStorage.setItem('userinfo', JSON.stringify(newuser) );

      } else {
        alert(`Simulation start failed.\n${responseData.resultMessage}`);
        return 1;
      }
    })
    .catch( error => {
      console.error(error);
      alert('Simulation start failed.');
      return 2;
    });

  }


  const doStopSimu = (event, values) => {
    event.preventDefault();

    setReadyToStart(false);


    fetch(`${GREENERGENIC_CONFIG.HOSTNAME}/stop_simu`,
    {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({action: 'stop'})
    })
    .then( response => {
      return response.json();
    }).then(responseData => {

      // console.log(responseData);

      if(responseData.resultCode === 200){
        // alert(`Simulation stopped successfully\n${responseData.resultMessage}`);
        alert(`Simulation stopped successfully`);

        setReadyToStart(true);
        //초기화 또는 '생성'버튼을 클릭하도록...

      } else {
        alert(`Simulation shutdown failed.\n${responseData.resultMessage}`);
        return 1;
      }
    })
    .catch( error => {
      console.error(error);
      alert('Simulation shutdown failed.');
      return 2;
    });

  }



  const makeEvData = (max_chgr) => {

    // if (max_chgr <= 1 || max_chgr >= 50) {
    //   alert(`CHGR수는 1 < x < 50 범위값을 입력해야 합니다.`);
    //   return;
    // }


    //기존에 등록된 모든 input params를 삭제함.
    remove(child(dbRef, `simu/params/`));


    let start_t = moment().add(10 + Math.round(Math.random() * 10), 'minutes');
    let datas = [];
    for (var i = 0; i < max_chgr; i++) {

      const model_random = (10 * Math.random()).toFixed(0);
      const leave_random = (15 * Math.random()).toFixed(0); //최대 5시간
      // const start_random = (60 * Math.random()).toFixed(0); //최대 60분
      const start_random = (11 * Math.random()).toFixed(0); //최대 10분
      console.log(start_random);


      set( ref(database , 'simu/params/'+i), {
        idx: i,
        chgr_id: String(i + 1).padStart(2, '0'),
        on_time: start_t.format('YY/MM/DD HH:mm'),
        off_time: moment(start_t).add(leave_random + 1, 'minutes').format('YY/MM/DD HH:mm'),
        current_avail_dis: Math.floor(Math.random() * 100) + 41,
        desired_driving_dis: Math.floor(Math.random() * 70) + 153,
        ev_model: ev_model_list[model_random],
        profile:0,
        isNew: false,
        isActive: false
      });


      datas.push({
        idx: i,
        chgr_id: String(i + 1).padStart(2, '0'),
        on_time: start_t.format('YY/MM/DD HH:mm'),
        off_time: moment(start_t).add(leave_random + 1, 'minutes').format('YY/MM/DD HH:mm'),
        current_avail_dis: Math.floor(Math.random() * 100) + 41,
        desired_driving_dis: Math.floor(Math.random() * 70) + 153,
        ev_model: ev_model_list[model_random],
        profile:0,
        isNew: false,
        isActive: false
      });

      console.log("start_t1:", start_t);
      start_t.add(start_random, 'minutes');
      console.log("start_t2:", start_t);
    }

    props.updateMakeRandomEVData(datas);
    props.updateChgrCnt(max_chgr);
  }


  const handleMakeRanomData = (event, values) => {
    event.preventDefault();

    formik.setFieldValue('simu_speed', values.simu_speed);
    formik.setFieldValue('lc_max_supply', values.lc_max_supply);
    formik.setFieldValue('algorithm', values.algorithm);
    // formik.setFieldValue('chgr_cnt', values.chgr_cnt);
    formik.setFieldValue('offset_date', values.offset_date);

    if (checkParameters(values)){
      // makeEvData(values.chgr_cnt);
      makeEvData(selector_chgr_cnt);
      setReadyToStart(true);
    } else {
      setReadyToStart(false);
    }
  }


  const checkParameters = (values, ) => {

    try{
      if (! ( parseInt(values.simu_speed) >= 100 && parseInt(values.simu_speed) <= 400) ) {
        alert('The simulation speed should be between 100 and 400.');
        return false;
      }

      if (!( parseInt(values.lc_max_supply) >= 10 && parseInt(values.lc_max_supply) <= 1000)) {
        alert('LC MAX Power should be between 10 and 1000.');
        return false;
      }

      if (!['basic', 'fully'].includes(values.algorithm)) {
        alert('The selected the algorithm is wrong.');
        return false;
      }

      if (!( parseInt(selector_chgr_cnt) >= 1 && parseInt(selector_chgr_cnt) <= 50)) {
        alert('The number of chargers should be between 1 and 50.');
        return false;
      }
      // if (!( parseInt(values.chgr_cnt) >= 1 && parseInt(values.chgr_cnt) <= 50)) {
      //   alert('The number of chargers should be between 1 and 50.');
      //   return false;
      // }

      if (!isDateValid(values.offset_date)){
        alert('The simulation offset datetime is wrong.');
        return false;
      }

    }catch(e){
      console.error(e);
      return false;
    }

    return true;

    // if(selector_random_ev_data == undefined || selector_random_ev_data.length == 0){
    //   alert('no data');
    //   return;
    // }
  }


  /**
   * 초기화
   * @param {*} values 
   * @param {*} formik 
   */
  const handleInit = (values, formik) => {

    setReadyToStart(false);

    values.simu_speed = INIT_SIMU_SPEED;
    values.lc_max_supply = INIT_LC_MAX_SUPPLY
    values.algorithm = INIT_ALGORITHM;
    // values.chgr_cnt = INIT_CHGR_CNT;
    values.offset_date = moment().format('YY/MM/DD HH:mm');
    formik.setFieldValue('lc_max_supply', INIT_LC_MAX_SUPPLY);

    props.updateChgrCnt(INIT_CHGR_CNT);

    //입력값을 초기화함.
    set(child(dbRef, 'simu/params/'), null);
    props.updateMakeRandomEVData([]);

    //집계 데이터 초기화
    set(child(dbRef, 'simu/summary/lc'), {
      total_charge_amount: 0.0,
      diff_amount: 0.0,
      cumulative_amount: 0.0,
      diff_cumulative: 0.0,
      predictive_amount: 0.0,
      diff_prediction: 0.0,
    });

    set(child(dbRef, 'simu/summary/chgrs'), {
      cnt_on_charge: 0.0,
      cnt_on_conn: 0.0,
      cnt_on_disconn: 0.0,
    });


    remove(child(dbRef, 'simu/summary/chgr'));

    //chgr를 12개 초기화한다.
    for(var i=0; i<INIT_CHGR_CNT; i++){
      set(child(dbRef, `simu/summary/chgr/${i}`), {
        chgr_id: "CHGR_" + String(i+1).padStart(2, "0"),
        charging: 0,
        diff_charging:0,
        cumulative_charging:0,
        diff_cumulative:0,
        remaining_charging:0
      });
    }


    remove(child(dbRef, 'simu/instantaneous/chgr'));

    //chgr를 12개 초기화한다.
    for(var i=0; i<INIT_CHGR_CNT; i++){
      set(child(dbRef, `simu/instantaneous/chgr/${i}`), {
        chgr_id: "CHGR_" + String(i+1).padStart(2, "0"),
        charging: 0,
        others: 100
      });
    }


    set(child(dbRef, 'simu/instantaneous/lc'), {
      total_charge_amount_ratio: 0.0,
      lc_max_profile:0.0,
    });

  }


  useEffect(()=>{
    if(selector_random_ev_data.length > 0){
      setReadyToStart(true);
    }else{
      setReadyToStart(false);
    }

  },[selector_random_ev_data]);



  return (
    <div className={classes.root}>

      <Formik
        {...formik}
        enableReinitialize={false}
      >

        {({
          errors,
          handleBlur,
          handleChange,
          isSubmitting,
          touched,
          values,
          setFieldValue
        }) => (

          <form>
            <Card
              raised={false}
              style={{ alignItems: "flex-start", 
              // padding:theme.spacing(1)
             }}
            >

              <CardHeader align="center"
                title={<Typography variant="h5">{i18n.t("simulation_title")}</Typography>}
                style={{
                  borderBottom: "thick double darkgray",
                  // marginBottom: "10px", // Adjust the margin as needed
                  // paddingTop: "0", // Set padding-top to 0
                  marginInline: "2em",
                  backgroundColor: "lightgray",
                  // paddingTop: "10px",
                  marginTop: "10px",
                }}
              />


              <CardContent >
                <Grid container item md={12} xs={12} spacing={1} direction="row" alignItems="center" style={{ marginBlock: "10px" }}>
                  <Grid item md={2} xs={4}>

                    <Autocomplete
                      id="admin_type"
                      options={simu_speed_list}
                      classes={{ option: classes.options, }}
                      autoHighlight
                      getOptionSelected={(option, value) => option === value}
                      // value={selectedAdminType}
                      value={values.simu_speed}
                      renderOption={(option) => (
                        <React.Fragment>
                          {option}
                        </React.Fragment>
                      )}

                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={i18n.t("simulation_speed")}
                          variant="outlined"
                          // required
                          fullWidth
                          inputProps={{
                            ...params.inputProps,
                          }}
                        />
                      )}

                      // onChange={handleChange}
                      onChange={(e, value) => setFieldValue("simu_speed", value)}

                    // onChange={(event, newValue) => {
                    //   if (newValue) {
                    //     // setSelectedAdminType(newValue);
                    //   }
                    // }}
                    />

                  </Grid>


                  {/* <Grid item md={2} xs={4}>
                    <Typography variant="body1" align='right' paddingRight={2}>LC 최대 공급 전력량<Typography variant="caption" paddingLeft={0.2}>[kWh]</Typography></Typography>
                  </Grid> */}

                  <Grid item md={2} xs={4}>

                    <TextField
                      error={Boolean(touched.lc_max_supply && errors.lc_max_supply)}
                      fullWidth
                      helperText={touched.lc_max_supply && errors.lc_max_supply}
                      label={`${i18n.t("LC_MAX_power")}(<${MAX_LENGTH.LC_MAX_SUPPLY}) [kWh]`}
                      name="lc_max_supply"
                      // value={selector_selectedStationInfo.statName}
                      // onBlue={handleBlur}
                      onChange={handleChange}
                      value={values.lc_max_supply}
                      variant="outlined"
                      inputProps={{ maxLength: MAX_LENGTH.LC_MAX_SUPPLY, readOnly: false, style: { textAlign: 'right' } }}
                      InputLabelProps={{ shrink: true }}
                    />

                  </Grid>

                  {/* <Grid item md={2} xs={4}>
                    <Typography variant="body1" align='right' paddingRight={2}>LC의 CHGR수</Typography>
                  </Grid> */}



                  <Grid item md={2} xs={4}>

                    <Autocomplete
                      id="algorithm_type"
                      options={simu_algorithm_list}
                      classes={{ option: classes.options, }}
                      autoHighlight
                      getOptionSelected={(option, value) => option === value}
                      value={values.algorithm}
                      renderOption={(option) => (
                        <React.Fragment>
                          {option}
                        </React.Fragment>
                      )}

                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={i18n.t("charging_algorithm")}
                          variant="outlined"
                          // required
                          fullWidth
                          inputProps={{
                            ...params.inputProps,
                          }}
                        />
                      )}
                      onChange={(e, value) => setFieldValue("algorithm", value)}
                    />
                  </Grid>



                  <Grid item md={2} xs={4}>
                    <TextField
                      error={Boolean(touched.offset_date && errors.offset_date)}
                      fullWidth
                      helperText={touched.offset_date && errors.offset_date}
                      label={i18n.t("simulation_offset_time")}
                      name="offset_data"
                      onChange={(e) => {
                        handleChange(e);
                        setFieldValue("offset_date", e.target.value);
                      }}
                      value={values.offset_date}
                      variant="outlined"
                      inputProps={{ maxLength: MAX_LENGTH.DATETIME, readOnly: false, style: { textAlign: 'left' } }}
                      InputLabelProps={{ shrink: true }}
                    />

                  </Grid>

                  <Grid item md={2} xs={4}>

                    <TextField
                      error={Boolean(touched.chgr_cnt && errors.chgr_cnt)}
                      fullWidth
                      helperText={touched.chgr_cnt && errors.chgr_cnt}
                      label={`${i18n.t("simulation_offset_time")}(<50)`}
                      // label={`1 < x < 50`}
                      name="chgr_cnt"
                      // value={selector_selectedStationInfo.statName}
                      // onBlue={handleBlur}
                      onChange={(e) => {
                        // handleChange(e);
                        // setFieldValue("chgr_cnt", e.target.value);
                        props.updateChgrCnt(e.target.value);
                      }}
                      // value={values.chgr_cnt}
                      value={selector_chgr_cnt}
                      variant="outlined"
                      inputProps={{ maxLength: MAX_LENGTH.MAX_CHGR_CNT, readOnly: false, style: { textAlign: 'right' } }}
                      InputLabelProps={{ shrink: true }}
                    />

                  </Grid>



                  <Grid container item lg={2} md={2} xs={4} direction="row" justify="flex-start">
                    <Button activeClassName={classes.action}
                      variant="contained"
                      size="medium"
                      className={classes.button} onClick={(e) => { handleMakeRanomData(e, values) }}>
                      {i18n.t("create")}
                    </Button>

                    <Button activeClassName={classes.active}
                      size="small"
                      padding={0}
                      onClick={() => { setOpenUsage(!openUsage); }} >
                      {openUsage ? <ExpandLess /> : <ExpandMore />}
                    </Button>

                  </Grid>

                  {/* <Grid container item md={2} xs={4} direction="column" alignContent="flex-start">
                    <Button activeClassName={classes.active} className={classes.button} onClick={() => { setOpenUsage(!openUsage); }} >
                      {openUsage ? <ExpandLess /> : <ExpandMore />}
                    </Button>
                  </Grid> */}




                </Grid>


                <Collapse in={openUsage} timeout="auto" unmountOnExit>
                  <EVParamInput />
                </Collapse>
              </CardContent>


              <CardActions className={classes.actions}>
                <Grid container item className={classes.action}
                  direction="row" alignItems="center" justifyContent="center">

                  <Button
                    variant="contained"
                    color="primary"
                    // type="submit"
                    size="large"
                    // disabled={isSubmitting}
                    disabled={isReadyToStart == false}
                    className={classes.action}
                    onClick={(e) => doStartSimu(e, values)}
                  >
                    {i18n.t("start")}
                  </Button>

                  <Button
                    variant="outlined"
                    size="large"
                    // onClick={handleBack}
                    onClick={(e) => doStopSimu(e, values)}
                    className={classes.action}
                  >
                    {i18n.t("stop")}
                  </Button>


                  <Button
                    variant="outlined"
                    size="large"
                    // type="abort"
                    onClick={(e) => { handleInit(values, formik); }}
                    className={classes.action}
                  >
                  {i18n.t("init")}
                  </Button>
                </Grid>
              </CardActions>

            </Card>
          </form>
        )}
      </Formik>

    </div>
  );

};



SmartChargingInput.propTypes = {
  className: PropTypes.string,
  history: PropTypes.object,
};


const mapDispatchToProps = dispatch => {
  return bindActionCreators({
    updateSimuSetting,
    updateMakeRandomEVData,
    updateChgrCnt,
  }, dispatch);
};


let mapStateToProps = (state) => {
  return { simuSettings: state.simuSettings }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps)
  (SmartChargingInput);
// export default SmartChargingInput;



const theme = createTheme({
  spacing: 4,
})

const useStyles = makeStyles(() => ({
  root: {
    padding: theme.spacing(1),
  },
  content: {
    marginTop: theme.spacing(1),
  },
  action: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    "& + &": {
      marginLeft: theme.spacing(1),
    },
  },

  queryField: {
    flexBasis: 220,
    marginRight: 20,
  },
  bulkAction: {
    marginLeft: theme.spacing(2),
  },

  divider: {
    margin: theme.spacing(2, 0)
  },
}));